/***
 *
 *   MODAL STYLES
 *   Ported from ui-reference/src/components/ui/dialog.tsx.
 *
 *   Replaces modal.scss, which positioned the surface with absolute offsets
 *   and floated the form buttons at 49% width each.
 *
 **********/

const Style = {
    overlay: 'fixed inset-0 z-[1001] bg-black/40 backdrop-blur-sm animate-fade-in',
    wrapper: 'fixed inset-0 z-[1002] flex items-center justify-center p-4 pointer-events-none',
    content: `pointer-events-auto relative max-h-[calc(100vh-2rem)] w-full overflow-y-auto rounded-xl border
    bg-surface-elevated p-6 text-left shadow-lg animate-scale-in`,
    header: 'mb-4 space-y-1.5 pr-8 text-left',
    title: 'text-lg font-semibold text-text-primary',
    text: 'text-sm text-text-secondary',
    close: `absolute right-4 top-4 rounded-sm text-text-secondary opacity-70 transition-opacity hover:opacity-100
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
};

export default Style;
